import * as React from "react";

const BellOutline = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="M21.673 18.553A9.598 9.598 0 0 1 20 16.6a8.42 8.42 0 0 1-.9-3.207V10.1a7.207 7.207 0 0 0-6.294-7.167v-.86a.89.89 0 1 0-1.78 0v.874a7.207 7.207 0 0 0-6.22 7.153v3.293a8.42 8.42 0 0 1-.9 3.207 9.598 9.598 0 0 1-1.646 1.953.667.667 0 0 0-.227.5v.907a.667.667 0 0 0 .667.667h18.533a.667.667 0 0 0 .667-.667v-.907a.668.668 0 0 0-.227-.5Zm-18.253.74c.62-.599 1.166-1.27 1.627-2a9.493 9.493 0 0 0 1.1-3.9V10.1a5.827 5.827 0 1 1 11.646 0v3.293a9.492 9.492 0 0 0 1.1 3.9c.46.73 1.007 1.401 1.627 2H3.42ZM12 22.853a1.78 1.78 0 0 0 1.72-1.52h-3.507A1.78 1.78 0 0 0 12 22.853Z"
      fill="currentColor"
    />
  </svg>
);

export default BellOutline;
